import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Navigation from "../Navigation/Navigation";
import Footer from "../Footer/Footer";

const BlogDetails = () => {
  const { Id } = useParams();
  const [singleDetails, setSingleDetails] = useState([]);
  const [getDetails, setGetDetails] = useState({});

  useEffect(() => {
    fetch("../blog.json")
      .then((res) => res.json())
      .then((data) => setSingleDetails(data));
  }, []);

  useEffect(() => {
    const details = singleDetails.find((td) => td?.id == Id);
    setGetDetails(details);
  }, [singleDetails]);

  return (
    <>
      <Navigation />
      <div className="text-white" id="project-details">
        <div className="w-50 mx-auto my-4">
          <img src={getDetails?.img} alt="" />
          <h2 className="text-left my-2">{getDetails?.title}</h2>
          <p className="py-4">{getDetails?.description}</p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogDetails;
